angular
    .module('qkr')
    .controller('couponCreateController',
        ($scope, $rootScope, $location, couponService, imageService,
         createCouponInitData, $uibModal, $timeout, messageService, gettextCatalog, FormHelper, utils) => {
            $scope.productList = createCouponInitData.productConfig.products;
            $scope.selectedProducts = createCouponInitData.productConfig.selectedProducts;
            $scope.coupon = createCouponInitData.coupon;
            $scope.commonConfig = createCouponInitData.commonConfig;
            $scope.locations = createCouponInitData.locationConfig.locations;
            $scope.commonConfig = createCouponInitData.commonConfig;
            $scope.merchantInfo = createCouponInitData.merchantInfo;
            $scope.isEdit = createCouponInitData.commonConfig.isEdit;
            $scope.outletLevel = createCouponInitData.commonConfig.outletLevel;
            $scope.privileged = createCouponInitData.commonConfig.privileged;
            $scope.readOnly = createCouponInitData.commonConfig.readOnly;
            $scope.canEdit = createCouponInitData.commonConfig.canEdit;
            $scope.coupons = createCouponInitData.coupons;
            $scope.showQr = $scope.isEdit &&
                (createCouponInitData.coupon.aquireMechanism === 'QRCODE' ||
                    !createCouponInitData.coupon.aquireMechanism);
            $scope.deptBasedCoupon = createCouponInitData.commonConfig.deptBasedCoupon;
            $scope.validationError = false;
            $scope.saving = false;

            const formHelper = new FormHelper($scope);

            $scope.acquisitionTypes = [
                {
                    type: 'QRCODE',
                    description: gettextCatalog.getString(
                        'Scan a QR code or type the coupon code'
                    ),
                    privilegedOnly: false
                }
            ];

            if ($scope.readOnly) {
                // Set fieldset children to be disabled
                $timeout(
                    () => {
                        angular.element('#couponForm :input').prop('disabled', true);
                        angular.element('#minCartTotal').prop('disabled', true);
                        angular.element('#maxDiscount').prop('disabled', true);
                    },
                    1000
                );
            }


            $scope.validate = function() {
                $scope.errors = null;
                const errors = {
                    detailsErrors: {},
                    termsErrors: {},
                    typeErrors: {},
                    redemptionErrors: {},
                    availabilityErrors: {}
                };

                let elementId = null;
                // Use this to set focus on whatever input field is invalid
                if (
                    typeof $scope.coupon.value === 'string' ||
                    $scope.coupon.value instanceof String
                ) {
                    $scope.coupon.value = parseInt($scope.coupon.value, 10);
                }

                if ($scope.coupon.binRanges) {
                    angular.forEach($scope.coupon.binRanges, binRange => {
                        if (!binRange.match(/^\d*$/)) {
                            errors.binRanges = gettextCatalog.getString(
                                'BIN ranges must be only numbers with no letters, special characters or spaces'
                            );
                            elementId = 'binRanges';
                        }
                    });
                }

                if ($scope.couponForm.type.$error.required) {
                    errors.typeErrors.type = gettextCatalog.getString('');
                    if (!elementId) {
                        elementId = 'type';
                    }
                }


                // Make sure label is uppercase
                if ($scope.coupon.label) {
                    $scope.coupon.label = $scope.coupon.label.toUpperCase();
                }

                if (
                    utils.isEmpty(errors.detailsErrors) &&
                    utils.isEmpty(errors.termsErrors) &&
                    utils.isEmpty(errors.typeErrors) &&
                    utils.isEmpty(errors.availabilityErrors) &&
                    !errors.binRanges
                ) {
                    $scope.validationError = false;
                    return true;
                } else {
                    $scope.validationError = true;
                    if (elementId) {
                        utils.setFocus(elementId);
                    }
                    $scope.errors = errors;
                    return false;
                }
            };

            $scope.showPreview = function() {
                $uibModal.open({
                    template: require('../../coupons/templates/couponPreview.html'),
                    controller: 'couponPreviewController',
                    windowClass: 'modal-image modal-borderless draggable',
                    size: 'sm',
                    backdrop: 'static',
                    resolve: {
                        coupon() {
                            return $scope.coupon;
                        },
                        merchantInfo() {
                            return $scope.merchantInfo;
                        }
                    }
                });
            };

            $scope.cancel = function() {
                utils.scrollToTop();
                $location.path('/merchant/coupons');
            };

            $scope.allowedActivateNow = function() {
                return couponService.allowedActivate($scope.coupon, $scope.coupons);
            };

            $scope.save = function(isValid, asDraft) {
                if (!isValid) {
                    return;
                }

                if ($scope.coupon.aquireMechanism === 'PURCHASE_REWARD') {
                    if ($scope.coupon.binRanges) {
                        $scope.coupon.binRange = $scope.coupon.binRanges.join();
                    } else {
                        $scope.coupon.binRange = null;
                    }
                }

                if ($scope.validate()) {
                    // If at outlet level we have already populated applicableLocations with the id of the outlet
                    // the user is in, otherwise we'll need to set up the applicableLocations for the coupon made
                    // at merchant level
                    // But for schools we need to go through locations (departments) as if we were at merchant
                    // level going through outlets
                    if (!$scope.outletLevel || $scope.outletLevel && $scope.deptBasedCoupon) {
                        $scope.coupon.applicableLocations = [];
                        let allSelected = true;
                        // Assume all locations selected
                        for (let i = 0; i < $scope.locations.length; ++i) {
                            const loc = $scope.locations[i];
                            if (loc.selected) {
                                $scope.coupon.applicableLocations.push({id: loc.id});
                            } else {
                                allSelected = false; // Found a location not selected
                            }
                        }

                        if (allSelected) {
                            $scope.coupon.applicableLocations = [];
                        }
                    }

                    if (
                        $scope.coupon.type === 'COUPON_AMOUNT_OFF_BASKET' ||
                        $scope.coupon.type === 'COUPON_PERCENT_OFF_BASKET'
                    ) {
                        $scope.coupon.variants = [];
                    }

                    $scope.coupon.isDraft = asDraft;
                    $scope.hasExpiryDate = $scope.coupon.expiryDate !== null &&
                        $scope.coupon.expiryDate !== undefined;
                    $scope.saveValidatedCoupon($scope.coupon.isDraft);
                }
            };

            $scope.saveValidatedCoupon = function(isDraft) {
                $scope.saving = true;

                if ($scope.hasExpiryDate) {
                    $scope.coupon.expiryDateStr = utils.dateToServerDateString(
                        $scope.coupon.expiryDate
                    );
                } else {
                    $scope.coupon.expiryDateStr = undefined;
                    $scope.coupon.expiryDate = undefined;
                }

                $scope.coupon.startDateStr = utils.dateToServerDateString(
                    $scope.coupon.startDate
                );
                const coupon = angular.copy($scope.coupon);

                // Don't send temporary variables "amount" or "percent", just send
                // "value" otherwise logs look confusing (one of
                // Them will be out of date depending on the coupon type)
                delete coupon.amount;
                delete coupon.percent;

                if (!$scope.isEdit) {
                    // Open confirmation modal
                    const confirmationModal = openConfirmationModal(isDraft);

                    confirmationModal.result.then(result => {
                        if (result === 'ok') {
                            if (
                                $scope.coupon.imageUrl && $scope.coupon.imageUrl.length === 0 ||
                                !$scope.coupon.imageUrl
                            ) {
                                $scope.coupon.imageUrl = $scope.merchantInfo.coverImage;
                            }

                            couponService
                                .createCoupon(coupon)
                                .then($scope.saveCouponCallback, $scope.saveCouponCallback);
                        } else if (result === 'cancel') {
                            $scope.coupon.isDraft = false;
                            $scope.saving = false;
                        }
                    });
                } else {
                    couponService
                        .updateCoupon(coupon)
                        .then($scope.saveCouponCallback, $scope.saveCouponCallback);
                }
            };

            $scope.saveCouponCallback = function(promise) {
                const r = formHelper.handleResponse(promise);
                if (r.isSuccess()) {
                    utils.scrollToTop();
                    // If new coupon and not a draft we want to open the QR code modal
                    if (!$scope.isEdit) {
                        messageService.saveAlert('Coupon Created');
                        if (
                            !$scope.coupon.isDraft && $scope.coupon.aquireMechanism === 'QRCODE'
                        ) {
                            const qrModal = couponService.openQRModal(promise.data);
                            qrModal.result.then(() => {
                                $location.path('/merchant/coupons');
                            });
                        } else {
                            $location.path('/merchant/coupons');
                        }
                    } else {
                        messageService.saveAlert('Coupon Saved');
                        $location.path('/merchant/coupons');
                    }
                } else {
                    if (promise.data.errors) {
                        const labelError = promise.data.errors.find(
                            e => e.field === 'label'
                        );
                        if (labelError) {
                            utils.setFocus('label');
                            $scope.errors = {};
                            $scope.errors.detailsErrors = {};
                            $scope.errors.detailsErrors.label = labelError.reason;
                        }

                        angular.forEach(promise.data.errors, value => {
                            $scope.errors[value.field] = value.reason;
                        });
                    } else {
                        messageService.error(
                            gettextCatalog.getString('An unexpected error occurred')
                        );
                    }

                    $scope.saving = false;
                }
            };

            /*
           * Function to open the choose image modal dialog
           */
            $scope.selectCouponImage = function($files, imageType) {
                imageService.editingImageReferenceName = 'COUPON_' + Math.random();

                $rootScope.requiredAspectRatio = 2.664;
                $rootScope.scaledWidthAbsolute = 666;

                $scope.updatingImage = imageType;

                const modalInstance2 = $uibModal.open({
                    template: require('../../templates/imageUpload.html'),
                    controller: 'ImageController',
                    windowClass: 'modal-image modal-borderless',
                    size: 'sm',
                    backdrop: 'static',
                    resolve: {
                        inputImage() {
                            return $files;
                        }
                    }
                });

                // Hack to get rid of scrollbar that appears on the outside of modals sometimes
                $timeout(
                    () => {
                        const modalContainer = angular.element('.modal');
                        modalContainer.css('overflow-y', 'hidden');
                    },
                    1000
                );

                modalInstance2.result.then(selectedItem => {
                    if (selectedItem === 'cancel' && $scope.coupon.imageUrl.length === 0) {
                        $scope.coupon.imageUrl = '';
                    } else if (selectedItem != 'cancel') {
                        $scope.coupon.imageUrl = selectedItem.mediaValue + '?decache=' +
                            new Date().getTime();
                    }
                });
            };

            const getMessage = function(isDraft, allowedActivate) {
                if (!isDraft) {
                    if (allowedActivate) {
                        return gettextCatalog.getString(
                            'Clicking Save will mean the coupon can be acquired and redeemed immediately'
                        );
                    } else {
                        return gettextCatalog.getString(
                            'You are only allowed to have one purchase reward coupon active at a time. ' +
                            'Would you like to deactivate other purchase reward coupons and use this one?'
                        );
                    }
                } else {
                    return gettextCatalog.getString(
                        'You can activate this coupon from the coupon management dashboard'
                    );
                }
            };

            const getTitle = function(isDraft, allowedActivate) {
                if (!isDraft) {
                    if (allowedActivate) {
                        return gettextCatalog.getString('Save Coupon');
                    } else {
                        return gettextCatalog.getString('Save Coupon');
                    }
                } else {
                    return gettextCatalog.getString('Coupon saved as draft');
                }
            };

            const getButton = function(isDraft, allowedActivate) {
                if (!isDraft) {
                    if (allowedActivate) {
                        return gettextCatalog.getString('Save');
                    } else {
                        return gettextCatalog.getString('Yes');
                    }
                } else {
                    return gettextCatalog.getString('OK');
                }
            };

            const openConfirmationModal = function(isDraft) {
                const allowedActivate = couponService.allowedActivate($scope.coupon, $scope.coupons);

                const message = getMessage(isDraft, allowedActivate);
                const title = getTitle(isDraft, allowedActivate);
                const button = getButton(isDraft, allowedActivate);

                return $uibModal.open({
                    template: require('../../templates/common/modalDialog.html'),
                    controller: 'commonModalDialogController',
                    windowClass: 'fade',
                    backdrop: 'static',
                    resolve: {
                        title() {
                            return title;
                        },
                        confirmButtonName() {
                            return button;
                        },
                        confirmMsg() {
                            return message;
                        },
                        multiMsgArray() {
                            return [];
                        }
                    }
                });
            };
        });



// WEBPACK FOOTER //
// ./src/coupons/controllers/create.coupon.controller.js